import * as React from 'react';
/**
 *
 * Original name: multiple folders
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=22331%3A2794
 *
 */
export const MultipleFoldersPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 19h12.005a6.127 6.127 0 0 1 5.48 3.39L24.29 24H50v25.889a6.127 6.127 0 0 1-6.127 6.127H12.127A6.127 6.127 0 0 1 6 49.889V19Zm4 4v26.889c0 1.175.952 2.127 2.127 2.127h31.746A2.127 2.127 0 0 0 46 49.889V28H21.817l-1.91-3.823A2.127 2.127 0 0 0 18.005 23H10Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11h13.005a6.127 6.127 0 0 1 5.48 3.39L32.29 16H58v25.889a6.13 6.13 0 0 1-4 5.748V20H29.817l-1.91-3.823A2.127 2.127 0 0 0 26.005 15H13v-4Z", fill: "currentColor" })));
